module.exports = {};


//////////////////
// WEBPACK FOOTER
// C:/Users/gbelizaire/Documents/ang2tut/resulatbac/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0